// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errors-list[data-v-fb473f20] {
  list-style: inside;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/components/ModalValidations.vue","webpack://./ModalValidations.vue"],"names":[],"mappings":"AACA;EACE,kBAAA;ACAF","sourcesContent":["\r\n.errors-list {\r\n  list-style: inside;\r\n}\r\n",".errors-list {\n  list-style: inside;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
